<script>
const re = /^(?<value>([0-9]+)(\.[0-9]+)?)(?<prefix>[KMG]?)$/i
const PREFIX_MAP = { K: 1024, M: 1024 * 1024, G: 1024 * 1024 * 1024 }
const maxUploadSize = process.env.VUE_APP_MAX_UPLOAD_FILE_SIZE.match(re)
const MAX_FILE_IMPORT_SIZE = (maxUploadSize.groups.value ?? 1) * (PREFIX_MAP[maxUploadSize.groups.prefix.toUpperCase] ?? PREFIX_MAP.M)

export default {
  methods: {
    // 必須チェック
    validatorRequired (label, trigger) {
      const rule = {}
      rule.required = true
      rule.message = this.$fcMessage.getMessage('CMN0001E', '')
      if (trigger) {
        rule.trigger = trigger
      }
      return rule
    },
    // 必須チェック(日付範囲)
    validatorRangeRequired (label, trigger) {
      const rule = {}
      rule.validator = (rule, value, cb) => {
        if (!value || value.length === 0) {
          cb(new Error(rule.message))
        } else if (!value[0] || !value[1]) {
          cb(new Error(rule.message))
        } else {
          cb()
        }
      }
      rule.message = this.$fcMessage.getMessage('CMN0001E', '')
      if (trigger) {
        rule.trigger = trigger
      }
      return rule
    },
    // 属性チェック(半角大英字)
    validatorHalfUCaseAlphabet (label, trigger) {
      const rule = {}
      rule.pattern = /^[A-Z]+$/
      rule.message = this.$fcMessage.getMessage('CMN0002E', '', '半角英字大文字')
      if (trigger) {
        rule.trigger = trigger
      }
      return rule
    },
    // 属性チェック(半角大英数)
    validatorHalfUCaseAlphabetNumber (label, trigger) {
      const rule = {}
      rule.pattern = /^[A-Z0-9]+$/
      rule.message = this.$fcMessage.getMessage('CMN0002E', '', '半角英数')
      if (trigger) {
        rule.trigger = trigger
      }
      return rule
    },
    // 20220610髙森
    // 属性チェック(半角大英数と-(ハイフン))
    validatorHalfUCaseAlphabetNumberHyphen (label, trigger) {
      const rule = {}
      // rule.pattern = /^[A-Z0-9!-/:-@¥[-`{-~]+$/
      // 記号はハイフンのみOK
      rule.pattern = /^[A-Z0-9 -/]+$/
      rule.message = this.$fcMessage.getMessage('CMN0002E', '', '半角英数と-(ハイフン)')
      if (trigger) {
        rule.trigger = trigger
      }
      return rule
    },
    // 属性チェック(半角数字)
    validatorHalfNumber (label, trigger) {
      const rule = {}
      rule.pattern = /^[0-9]+$/
      rule.message = this.$fcMessage.getMessage('CMN0002E', '', '半角英字')
      if (trigger) {
        rule.trigger = trigger
      }
      return rule
    },
    // 属性チェック(数値)
    validateNumeric (label, fraction, trigger) {
      const rule = {}
      var pattern = '^[\\+\\-]?[0-9]+'
      var patternname = '数値'
      if (fraction > 0) {
        pattern += '(\\.[0-9]{1,' + fraction + '})?'
        patternname += '(小数第' + fraction + '位まで)'
      }
      pattern += '$'
      rule.pattern = new RegExp(pattern)
      rule.message = this.$fcMessage.getMessage('CMN0002E', '', patternname)
      if (trigger) {
        rule.trigger = trigger
      }
      return rule
    },
    // 属性チェック(電話番号(ハイフン無し))
    validatorTel (label, trigger) {
      const rule = {}
      rule.pattern = /^\+?[0-9]+$/
      rule.message = this.$fcMessage.getMessage('CMN0002E', '', '電話番号(ハイフン無し)')
      if (trigger) {
        rule.trigger = trigger
      }
      return rule
    },
    // 属性チェック(郵便番号)
    validatorZip (label, trigger) {
      const rule = {}
      rule.pattern = /^[0-9]{3}-[0-9]{4}$/
      rule.message = this.$fcMessage.getMessage('CMN0002E', '', '郵便番号(999-9999)')
      if (trigger) {
        rule.trigger = trigger
      }
      return rule
    },
    // 属性チェック(メールアドレス)
    validatorEmail (label, trigger) {
      const rule = {}
      rule.pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
      rule.message = this.$fcMessage.getMessage('CMN0002E', '', 'メールアドレス形式')
      if (trigger) {
        rule.trigger = trigger
      }
      return rule
    },
    // 属性チェック(正規表現)
    validatorRegExp (label, pattern, patternname, trigger) {
      const rule = {}
      rule.pattern = new RegExp(pattern)
      rule.message = this.$fcMessage.getMessage('CMN0002E', '', patternname)
      if (trigger) {
        rule.trigger = trigger
      }
      return rule
    },
    // 分母と分子の大小比較
    validatorFractionCheck (label, trigger) {
      const rule = {}
      rule.validator = (rule, value, cb) => {
        var fraction = value.split('/')
        if (parseInt(fraction[0]) > parseInt(fraction[1])) {
          cb(new Error(rule.message))
        } else {
          cb()
        }
      }
      rule.message = this.$fcMessage.getMessage('CMN0002E', '', '分母≧分子')
      if (trigger) {
        rule.trigger = trigger
      }
      return rule
    },
    // インポートファイルチェック(選択チェック)
    validatorFileSelected (upload, extension) {
      const rule = {}
      rule.validator = (rule, value, cb) => {
        const files = upload.uploadFiles
        if (files.length === 0) {
          cb(rule.message)
        } else {
          cb()
        }
      }
      rule.message = this.$fcMessage.getMessage('CMN0012E', extension)
      return rule
    },
    // インポートファイルチェック(拡張子チェック)
    validatorFileExtension (upload, extension) {
      const rule = {}
      rule.validator = (rule, value, cb) => {
        const re = new RegExp('\\.' + extension + '$', 'i')
        const files = upload.uploadFiles
        if (!re.test(files[0].name)) {
          cb(rule.message)
        } else {
          cb()
        }
      }
      rule.message = this.$fcMessage.getMessage('CMN0012E', extension)
      return rule
    },
    // インポートファイルチェック(0サイズチェック)
    validatorFileEmpty (upload) {
      const rule = {}
      rule.validator = (rule, value, cb) => {
        const files = upload.uploadFiles
        if (files[0].size === 0) {
          cb(rule.message)
        } else {
          cb()
        }
      }
      rule.message = this.$fcMessage.getMessage('CMN0013E')
      return rule
    },
    // インポートファイルチェック(最大サイズチェック)
    validatorFileMaxSize (upload) {
      const rule = {}
      rule.validator = (rule, value, cb) => {
        const files = upload.uploadFiles
        if (files[0].size >= MAX_FILE_IMPORT_SIZE) {
          cb(rule.message)
        } else {
          cb()
        }
      }
      rule.message = this.$fcMessage.getMessage('CMN0039E', MAX_FILE_IMPORT_SIZE)
      return rule
    }
  }
}
</script>
